<template>
  <form>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex lg6 xs12>
          <v-radio-group v-model="generalForm.dri" row v-validate="'required'" data-vv-name="dri" :data-vv-as="labels.dri" :error-messages="errors.collect('dri')">
            <v-radio v-for="dri in driList" :label="dri.label" :value="dri.value" :key="dri.value"></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex lg6 xs12>
          <v-checkbox v-model="generalForm.coinsurance" :label="labels.coinsurance" data-vv-name="coinsurance" :data-vv-as="labels.coinsurance" :error-messages="errors.collect('coinsurance')" class="coinAlign"></v-checkbox>
        </v-flex>
        <v-flex lg6 xs12>
          <v-select :items="branchList" v-model="generalForm.branch" :label="labels.branch" item-text="label" item-value="value" data-vv-name="branch" :data-vv-as="labels.branch" :error-messages="errors.collect('branch')" v-validate="'required'"></v-select>
        </v-flex>
        <v-flex lg6 xs12>
          <v-select :items="polTypeList" v-model="generalForm.polType" :label="labels.polType" item-text="label" item-value="value" data-vv-name="polType" :data-vv-as="labels.polType" :error-messages="errors.collect('polType')" v-validate="'required'"></v-select>
        </v-flex>
      </v-layout>
    </v-container>
  </form>
</template>

<script>
import { dri } from '@/const/underwriting'

export default {
  data() {
    return {
      labels: {
        dri: 'Direct / Reinsurance',
        coinsurance: 'Apply Coinsurance?',
        branch: 'Branch*',
        polType: 'Policy Type*',
        busSrc: 'Business Source'
      },
      generalForm: {
        dri: 'D',
        coinsurance: false,
        branch: undefined,
        polType: undefined,
        busSrc: undefined
      },
      driList: dri,
      branchList: [
        {
          label: 'Head Office',
          value: 'HO'
        }, {
          label: 'My Office',
          value: 'MO'
        }
      ],
      polTypeList: [
        {
          label: 'Travel Package',
          value: 'TP'
        }, {
          label: 'Motor Private Car',
          value: 'MPC'
        }
      ],
      busSrcList: [
        {
          label: 'Travel Package',
          value: 'TP'
        }, {
          label: 'Motor Private Car',
          value: 'MPC'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.coinAlign {
  // To align coinsurance with dri (if they were to be on the same line)
  padding: 18px 0 0;
}
</style>
